import { useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import useGetItineraryId from '../useGetItineraryId'

interface UseGetFlightsFromItineraryParams {
    skip?: boolean
}

const useGetFlightsFromItinerary = ({ skip = false }: UseGetFlightsFromItineraryParams) => {
    const itineraryId = useGetItineraryId()
    const { flights = [] } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            skip,
            selectFromResult: ({ data }) => ({
                flights: data?.flights || []
            })
        }
    )
    return skip ? [] : flights
}

export default useGetFlightsFromItinerary
